import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Modal, Label, Button, FormFeedback, Input } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";

import Select from "react-select";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import moment from 'moment';
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import { checkFileValidation } from "../../Utils/Common";
import { formatCurrency, formatDate } from '../../Utils/formatters';


const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const TaxDocuments = props => {
  //meta title
  document.title = "Tax Documents";
  const { getRequest, postRequest, postRequestByFormData } = useRequests();

  
  const [AlertData, setAlertData] = React.useState({
        variant: '',
        message: '',
    });
    const resetAlertData = () => {
        setTimeout(() => {
            setAlertData((AlertData) => ({
                ...AlertData,
                variant: '',
                message: '',
            }));
        }, 5000);
    };

    const [StandardModal4, setStandardModal4] = React.useState(false);
    const togStandardModal4 = async () => {
        setStandardModal4(true);
    }

    const [File, setFile] = useState();
    const [FileName, setFileName] = useState('');
    const saveFile = (e) => {
        if((e.target.files).length > 0) {
        setFile(e.target.files[0]);
        setFileName(e.target.files[0].name);

        var validationRes = checkFileValidation(e.target.files[0]);
        if (!validationRes.status) {
            setFile();
            setFileName('');

            setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: validationRes.msg,
            }));
            resetAlertData();

            return false;
        }
        }
    };

    const validation5 = useFormik({
    enableReinitialize: true,

    initialValues: {
      name: '',
      type: "",
      period: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required(
        "Name is required",
      ),
      type: Yup.string().required(
        "Type is required",
      ),
      period: Yup.string().required(
        "Period is required",
      ),
    }),
    onSubmit: async (values) => {
        try {
          if (FileName === '') {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: 'Please select a document!',
            }));
            return;
          }

          let submit5 = document.getElementById('submit5');
          submit5.disabled = true;
          submit5.textContent = 'Processing...';

         const formData = new FormData();
          formData.append("u_id", validation1.values.user.value);
          formData.append("name", values.name);
          formData.append("type", values.type);
          formData.append("period", values.period);
          formData.append("file", File);
          formData.append("fileName", FileName);

          const res = await postRequestByFormData('upload-tax-document', formData);
          if (res && res.code === 200) {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'success',
              message: res.message,
            }));

            validation5.resetForm();
            setFile(null);
            setFileName('');
            handleLoadGetDocumentsData();
            setTimeout(() => {
              validation1.handleSubmit();
            }, 500);
            setStandardModal4(false);
          }
          else {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: res.message,
            }));
          }
          resetAlertData();

          submit5.disabled = false;
          submit5.textContent = 'Upload';
        
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      user: {label: 'All', value: 'All'},
      status: 'All',
    },
    validationSchema: Yup.object({
    }),
    onSubmit: (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        let filteredData = DocumentsData;
        if(values.user.value !== 'All') {
          filteredData = filteredData.filter(item => String(item.u_id) === String(values.user.value));
        }
        if(filteredData.length > 0) {

            let userUploadedDocs = filteredData.filter(item => item.uploaded_by === 'user');

            let adminUploadedDocs = filteredData.filter(item => item.uploaded_by === 'admin');

                if(userUploadedDocs.length <= 0){
                    let tempTBody = (<tr>
                                    <td colSpan="9" className="text-center">No records found</td>
                                </tr>);
                    setDocumentsTBody(tempTBody);
                }else{
                    handleT1Body(userUploadedDocs, FilePath);
                }

                if(adminUploadedDocs.length <= 0){
                    let tempTBody = (<tr>
                                    <td colSpan="9" className="text-center">No records found</td>
                                </tr>);
                    setDocumentsTBody1(tempTBody);
                }else{
                    handleT1Body1(adminUploadedDocs, FilePath);
                }

        }
        else {
          let tempTBody = (<tr>
                          <td colSpan="9" className="text-center">No records found</td>
                        </tr>);

          setDocumentsTBody(tempTBody);
          setDocumentsTBody1(tempTBody);
        }

        submit1.disabled = false;
        submit1.textContent = 'Search';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [Transaction, setTransaction] = React.useState([]);
  const [StandardModal1, setStandardModal1] = React.useState(false);
  const togStandardModal1 = async (elementData) => {
    setTransaction(elementData);
    setStandardModal1(true);
  }

  const [StandardModal2, setStandardModal2] = React.useState(false);
  const togStandardModal2 = async (elementData) => {
    validation2.setValues({
      ...validation2.values,
      td_id: elementData.td_id,
      status: elementData.status,
      information: elementData.information,
    });
    setStandardModal2(true);
  }

  const validation2 = useFormik({
    enableReinitialize: true,

    initialValues: {
      td_id: '',
      status: '',
      information: '',
    },
    validationSchema: Yup.object({
      status: Yup.string().required('Please select status'),

    information: Yup.string().when('status', (status, schema) => {
        return status == 'Rejected'
            ? schema.required('Please enter Rejected reason')
            : schema.notRequired();
        }),
    }),
    onSubmit: async (values) => {
      try {

        let submit1 = document.getElementById('submit2');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          td_id: values.td_id,
          status: values.status,
          information: values.information
        });
        const res = await postRequest('update-document-status', jsonpar);
        if (res && res.code === 200) {
            handleLoadGetDocumentsData();
            setTimeout(() => {
              validation1.handleSubmit();
            }, 500);

            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'success',
              message: res.message,
            }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();
        
        submit1.disabled = false;
        submit1.textContent = 'Update';

        setStandardModal2(false);
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [DocumentsData, setDocumentsData] = React.useState([]);
  const [DocumentsTBody, setDocumentsTBody] = React.useState('');
  const handleT1Body = async (tempData, filepath) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.first_name}</td>
        <td>{element.last_name}</td>
        <td>{element.name}</td>
        <td>{element.type}</td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.status === 'Pending' ? 'badge-soft-warning' : element.status === 'Verified' ? 'badge-soft-success' : 'badge-soft-danger')}>{element.status}</span></td>
        <td>{formatDate(element.created_at)}</td>
        <td className="text-center">
          <button type="button" className="btn-sm btn btn-primary me-2"> {/* me-2 adds right margin */}
            <a
              rel="noreferrer"
              target="_blank"
              href={`${process.env.REACT_APP_API_URL}${filepath}${element.document}`}
              download={element.document}
              className="text-success"
              title="Download"
            >
              <i className="bx bx-download" style={{ fontSize: '1.2rem', color: 'white' }}></i>
            </a>
          </button>
          {element.status === 'Pending'?
            <Button type="button" title="Change Status" className="btn-sm btn btn-primary" onClick={(e)=>togStandardModal2(element)}><i className="bx bx-cog"></i></Button>
            : ''}
        </td>
      </tr>
    ));

    setDocumentsTBody(tempTBody);
  }

    const [DocumentsTBody1, setDocumentsTBody1] = React.useState('');
    const handleT1Body1 = async (tempData, filepath) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.first_name}</td>
        <td>{element.last_name}</td>
        <td>{element.name}</td>
        <td>{element.type}</td>
        <td>{element.period}</td>
        <td>{formatDate(element.created_at)}</td>
        <td className="text-center">
          <button type="button" className="btn-sm btn btn-primary me-2"> {/* me-2 adds right margin */}
            <a
              rel="noreferrer"
              target="_blank"
              href={`${process.env.REACT_APP_API_URL}${filepath}${element.document}`}
              download={element.document}
              className="text-success"
              title="Download"
            >
              <i className="bx bx-download" style={{ fontSize: '1.2rem', color: 'white' }}></i>
            </a>
          </button>
        </td>
      </tr>
    ));

    setDocumentsTBody1(tempTBody);
  }

const [FilePath, setFilePath] = React.useState('');
  const handleLoadGetDocumentsData = async () => {
    const res = await getRequest('get-tax-documents-data');
    if (res && res.code === 200) {
      setFilePath(res.data.url)

      let userUploadedDocs = res.data.data.filter(item => item.uploaded_by === 'user');
      if(userUploadedDocs.length <= 0){
        let tempTBody = (<tr>
                        <td colSpan="9" className="text-center">No records found</td>
                      </tr>);
        setDocumentsTBody(tempTBody);
      }else{
        handleT1Body(userUploadedDocs, res.data.url);
      }

      let adminUploadedDocs = res.data.data.filter(item => item.uploaded_by === 'admin');
      if(adminUploadedDocs.length <= 0){
        let tempTBody = (<tr>
                        <td colSpan="9" className="text-center">No records found</td>
                      </tr>);
        setDocumentsTBody1(tempTBody);
      }else{
        handleT1Body1(adminUploadedDocs, res.data.url);
      }

      setDocumentsData(res.data.data);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="9" className="text-center">No records found</td>
                      </tr>);

      setDocumentsTBody(tempTBody);
      setDocumentsTBody1(tempTBody);
    }
  }

  const [UsersData, setUsersData] = React.useState([]);
  const handleLoadGetUsers = async () => {
    const res = await getRequest('get-users');
    if (res && res.code === 200) {
      let tempArr = [{label: 'All', value: 'All'}];
      res.data.forEach(element => {
        let temp = {
            label: `${element.first_name} ${element.last_name} (${element.email})`,
            value: element.u_id,
        };
        tempArr.push(temp);
      });
      if (props.match.params.id) {
        let getUser = tempArr.find(element => String(element.value) === String(atob(props.match.params.id)));
        
        validation1.setValues({
          ...validation1.values,
          user: getUser,
        });

        setTimeout(() => {
          validation1.handleSubmit();
        }, 500);
      }
      tempArr = [{
          options: tempArr
      }];
      setUsersData(tempArr);
    }
  }
  React.useEffect(() => {
    handleLoadGetDocumentsData();
    handleLoadGetUsers();
  }, []);


  return (
    <React.Fragment>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Tax Documents")} />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div className="row">
                      <Col md={4} xs={12}>
                        <div className="mb-3 Register-Select2">
                          <label className="form-label">Users : </label>
                          <Select styles={colourStyles} value={validation1.values.user} onChange={(e) => validation1.setValues({ ...validation1.values, user: e })} options={UsersData} classNamePrefix="select2-selection" />
                        </div>
                      </Col>
                     
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label fullWidth">&nbsp; </label>
                          <Button type="button" 
                            id="submit1"
                            onClick={(e) => {
                              e.preventDefault();
                              validation1.handleSubmit();
                              return false;
                            }}
                          color="primary">Search</Button>
                        </div>
                      </Col>
                    </div>

                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    
                    <div className="table-responsive mb-0" data-pattern="priority-columns">
                        <div
                            className="text-muted mb-3"
                            style={{ fontSize: '0.95rem', marginLeft: '20px', fontWeight: 'bold' }}
                            >
                            Uploaded By Foreign User
                        </div>
                        <table className="table mb-0" style={{ minWidth: "1000px" }}>
                            <thead className="table-light">
                            <tr>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Status</th>
                                <th>Uploaded At</th>
                                <th className="text-center">Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            {DocumentsTBody}
                            </tbody>
                        </table>
                    </div>

                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
    
                    <div className="table-responsive mb-0" data-pattern="priority-columns">
                        <div
                        className="d-flex justify-content-between align-items-center mb-3"
                        style={{ fontSize: '0.95rem', marginLeft: '20px', marginRight: '20px', fontWeight: 'bold' }}
                    >
                        <span>Provided By Tokenized Green</span>
                        {validation1.values.user.value == "All"?
                        ""
                        :
                        <Button color="primary" onClick={(e)=>togStandardModal4()}>Upload</Button>
                        }
                    </div>

                        <table className="table mb-0" style={{ minWidth: "1000px" }}>
                            <thead className="table-light">
                            <tr>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Period</th>
                                <th>Issued On</th>
                                <th className="text-center">Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            {DocumentsTBody1}
                            </tbody>
                        </table>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal className="transation" centered backdrop="static" isOpen={StandardModal2}>
            <div className="modal-header">
              <h5 className="modal-title mt-0">Change Status</h5>
              <button type="button" onClick={(e)=>setStandardModal2(false)} className="close" data-dismiss="modal" aria-label="Close" >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Col md={12}>
                {/* <p className="AvailableBalance">Available Balance : <b>€5600</b></p> */}
                <div className="mb-3">
                  <Label className="form-label">Status : </Label>
                  <select className="form-select" name="status" value={validation2.values.status} onChange={(e) => validation2.setValues({ ...validation2.values, status: e.target.value })}>
                    <option value="Pending">Pending</option>
                    <option value="Verified">Verified</option>
                    <option value="Rejected">Rejected</option>
                  </select>
                  {validation2.touched.status && validation2.errors.status ? (
                    <FormFeedback type="invalid">{validation2.errors.status}</FormFeedback>
                  ) : null}
                </div>
              </Col>
              {validation2.values.status == "Rejected"?
                <Col xs={12}>
                    <div className="mb-3">
                    <label className="form-label">Rejected Reason	:</label>
                    <textarea
                        className="form-control"
                        name="information"
                        placeholder={'Rejected reason'}
                        onChange={validation2.handleChange}
                        value={validation2.values.information || ""}
                    >
                    </textarea>
                    </div>
                </Col>
              :""}
              
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary"
                id="submit2"
                onClick={(e) => {
                  e.preventDefault();
                  validation2.handleSubmit();
                  return false;
                }}
              > Update </button>
              <button type="button" className="btn btn-light" data-dismiss="modal" onClick={(e)=>setStandardModal2(false)} aria-label="Close">Close</button>
            </div>
          </Modal>

            <Modal className="transation" centered backdrop="static" isOpen={StandardModal4}>
            <div className="modal-header">
            <h5 className="modal-title mt-0">Upload Document</h5>
            <button type="button" onClick={(e)=>setStandardModal4(false)} className="close" data-dismiss="modal" aria-label="Close" >
                <span aria-hidden="true">&times;</span>
            </button>
            </div>
            <div className="modal-body">
            <Col xs={12}>
                <div className="mb-3">
                <label className="form-label">Name :</label>
                <Input 
                    name="name" 
                    type="text" 
                    placeholder={'Enter Name'}
                    onChange={validation5.handleChange}
                    onBlur={validation5.handleBlur}
                    value={validation5.values.name|| ""}
                    invalid={
                    validation5.touched.name && validation5.errors.name ? true : false
                    }
                />
                {validation5.touched.name && validation5.errors.name ? (
                    <FormFeedback type="invalid">{validation5.errors.name}</FormFeedback>
                ) : null}
                </div>

                <div className="mb-3">
                <label className="form-label">Type :</label>
                <Input 
                    name="type" 
                    type="text" 
                    placeholder={'Enter Type'}
                    onChange={validation5.handleChange}
                    onBlur={validation5.handleBlur}
                    value={validation5.values.type|| ""}
                    invalid={
                    validation5.touched.type && validation5.errors.type ? true : false
                    }
                />
                {validation5.touched.type && validation5.errors.type ? (
                    <FormFeedback type="invalid">{validation5.errors.type}</FormFeedback>
                ) : null}
                </div>

                <div className="mb-3">
                <label className="form-label">Period :</label>
                <Input 
                    name="period" 
                    type="text" 
                    placeholder={'Enter Period'}
                    onChange={validation5.handleChange}
                    onBlur={validation5.handleBlur}
                    value={validation5.values.period|| ""}
                    invalid={
                    validation5.touched.period && validation5.errors.period ? true : false
                    }
                />
                {validation5.touched.period && validation5.errors.period ? (
                    <FormFeedback type="invalid">{validation5.errors.period}</FormFeedback>
                ) : null}
                </div>

                <div className="mb-3">
                    <label className="form-label">Document : </label>
                    <Input
                    type="file"
                    className="form-control"
                    onChange={saveFile}
                    accept=".pdf,.jpg,.jpeg,.png"
                    />
                
                </div>
            </Col>
            </div>
            <div className="modal-footer">
            <button type="button" className="btn btn-primary"
                id="submit5"
                onClick={(e) => {
                e.preventDefault();
                validation5.handleSubmit();
                return false;
                }}
            > Upload </button>
            <button type="button" className="btn btn-light" data-dismiss="modal" onClick={(e)=>setStandardModal2(false)} aria-label="Close">Close</button>
            </div>
            </Modal>

        </Container>
      </div>

    </React.Fragment >
  );
};

export default withTranslation()(TaxDocuments);
